'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "TextOption": "Polaris-Listbox-TextOption",
  "allowMultiple": "Polaris-Listbox-TextOption--allowMultiple",
  "isAction": "Polaris-Listbox-TextOption--isAction",
  "disabled": "Polaris-Listbox-TextOption--disabled",
  "selected": "Polaris-Listbox-TextOption--selected",
  "Content": "Polaris-Listbox-TextOption__Content",
  "Checkbox": "Polaris-Listbox-TextOption__Checkbox"
};

exports.default = styles;
